// Shown when the app has no Supabase credentials yet. This is the first thing a
// new developer sees after `npm run dev` — it tells them exactly what to do.

import { Card } from "../components/ui";

export default function SetupNotice() {
  return (
    <div className="flex min-h-full items-center justify-center p-4">
      <div className="w-full max-w-lg">
        <Card>
          <h1 className="text-lg font-semibold text-slate-900">Almost there 👋</h1>
          <p className="mt-2 text-sm text-slate-600">
            OpsPanther needs a Supabase backend before it can run. To connect one:
          </p>
          <ol className="mt-3 list-decimal space-y-1 pl-5 text-sm text-slate-600">
            <li>
              Copy <code className="rounded bg-slate-100 px-1">.env.example</code> to{" "}
              <code className="rounded bg-slate-100 px-1">.env.local</code>
            </li>
            <li>
              Fill in <code className="rounded bg-slate-100 px-1">VITE_SUPABASE_URL</code> and{" "}
              <code className="rounded bg-slate-100 px-1">VITE_SUPABASE_ANON_KEY</code> from your
              Supabase project (Project Settings → API)
            </li>
            <li>
              Restart <code className="rounded bg-slate-100 px-1">npm run dev</code>
            </li>
          </ol>
          <p className="mt-3 text-sm text-slate-500">
            See <code className="rounded bg-slate-100 px-1">docs/ONBOARDING.md</code> for the full
            setup walkthrough.
          </p>
        </Card>
      </div>
    </div>
  );
}
